import { render, staticRenderFns } from "./Create-Costing.vue?vue&type=template&id=6996a718&scoped=true"
import script from "./Create-Costing.vue?vue&type=script&lang=js"
export * from "./Create-Costing.vue?vue&type=script&lang=js"
import style0 from "./Create-Costing.vue?vue&type=style&index=0&id=6996a718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996a718",
  null
  
)

export default component.exports